// libraries.
import { createSlice } from '@reduxjs/toolkit';

// store.
import { RootState } from '@store';

export const initialState = {
  websocketResponses: [],
  websocketLoading: false,
  websocketError: false,
};

export const domainWebSocketSlice = createSlice({
  name: 'domainWebSocketSlice',
  initialState,
  reducers: {
    setWebsocketResponses: (state, action) => {
      state.websocketResponses = action.payload;
    },
    setWebsocketLoading: (state, action) => {
      state.websocketLoading = action.payload;
    },
    setWebsocketError: (state, action) => {
      state.websocketError = action.payload;
    },
  },
});

export const { setWebsocketResponses, setWebsocketLoading, setWebsocketError } =
  domainWebSocketSlice.actions;

export const getWebsocketResponses = (state: RootState) =>
  state.domainWebSocket.websocketResponses;
export const getWebsocketLoading = (state: RootState) =>
  state.domainWebSocket.websocketLoading;
export const getWebsocketError = (state: RootState) =>
  state.domainWebSocket.websocketError;

export default domainWebSocketSlice.reducer;
